import { Typography, Box, LinearProgress, Grid } from "@material-ui/core";
import PoolCardStyle from "../Projects/PoolsStyle";
import { USDollar } from "../../utils/currency/usd";
import { Colors } from "../../helpers/theme";
const LinearProgressBar = (props:any) => {
  const classes = PoolCardStyle();
  return (
    <div>
      <Grid container>
        <Grid item xs={12} spacing={0}>
          {
            props.showFull && (
              <Box
                display="flex"
                flexDirection="row"
                justifyContent="space-between"
              >
                <Box
                  display="flex"
                  flexDirection="row"
                  alignItems="baseline"
                >
                  <Typography
                    style={{
                      fontWeight: 700,
                      fontSize: "19px",
                      color: "#060925",
                    }}
                  >
                    {
                      `${USDollar.format(props.totalRaised)}`
                    }
                  </Typography>
                  <Typography
                    style={{
                      fontWeight: 400,
                      fontSize: "12px",
                      marginLeft: "5px",
                    }}
                  >
                    USDC Raised
                  </Typography>
                </Box>
                <Box>
                  <Typography
                    style={{
                      fontWeight: 700,
                      fontSize: "19px",
                      color: "#060925",
                    }}
                  >
                    {/* {
                      Math.floor((props.totalRaised / props.maxRaise) * 100)
                    }% */}
                    {
                      `${USDollar.format(props.maxRaise)}`
                    }
                  </Typography>
                </Box>
              </Box>
            )
          }
        </Grid>
        <Grid item xs={12} spacing={0}>
            <LinearProgress 
              variant={props.value >= 0 ? "determinate" : "indeterminate"}
              style={{
                height: 10,
              }}
              {...props} 
            />
        </Grid>
        <Grid item xs={12} spacing={0}>
          {
            props.showFull && (
              <Box
                display="flex"
                flexDirection="row"
                justifyContent="space-between"
              >
                <Box>
                  <Typography
                    style={{
                      fontWeight: 700,
                      fontSize: "13px",
                      color: "#060925",
                    }}
                  >
                    {props.duration} day{props.duration > 1 && 's'} left
                  </Typography>
                </Box>
                <Box>
                  <Typography
                    style={{
                      fontWeight: 700,
                      fontSize: "13px",
                      color: "#060925",
                    }}
                  >
                    {
                      Math.floor((props.totalRaised / props.maxRaise) * 100)
                    }%
                  </Typography>
                </Box>
              </Box>
            )
          }
        </Grid>
      </Grid>
    </div>
  );
};


export default LinearProgressBar;